import { useState } from 'react';
import { downloadSteps } from '@/mocks/siteData';

export default function DownloadGuide() {
  const [activeTab, setActiveTab] = useState<'ios' | 'android'>('ios');

  return (
    <section id="download" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              开云体育app下载安装教程
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              四步完成下载安装，即刻开启体育竞技之旅
            </p>
          </div>

          <div className="flex justify-center mb-10">
            <div className="inline-flex bg-background-200/70 rounded-full p-1">
              <button
                className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeTab === 'ios'
                    ? 'bg-background-50 text-foreground-950'
                    : 'text-foreground-500 hover:text-foreground-700'
                }`}
                onClick={() => setActiveTab('ios')}
              >
                <i className="ri-apple-line mr-2 w-4 h-4 inline-flex items-center justify-center"></i>
                iOS 下载
              </button>
              <button
                className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeTab === 'android'
                    ? 'bg-background-50 text-foreground-950'
                    : 'text-foreground-500 hover:text-foreground-700'
                }`}
                onClick={() => setActiveTab('android')}
              >
                <i className="ri-android-line mr-2 w-4 h-4 inline-flex items-center justify-center"></i>
                安卓 下载
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {downloadSteps.map((step) => (
              <div key={step.step} className="relative group">
                <div className="p-6 rounded-xl bg-background-50 border border-background-200/70 h-full">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-heading font-bold text-lg mb-4">
                    {step.step}
                  </div>
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 mb-3">
                    <i className={`${step.icon} text-lg w-5 h-5 flex items-center justify-center`}></i>
                  </div>
                  <h3 className="font-semibold text-foreground-900 mb-2 text-base">
                    {step.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {step.description}
                  </p>
                </div>
                {step.step < 4 && (
                  <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                    <i className="ri-arrow-right-line text-foreground-300 text-xl w-5 h-5 flex items-center justify-center"></i>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-10 text-center">
            <div className="inline-flex flex-col sm:flex-row items-center gap-4 p-6 rounded-xl bg-background-50 border border-background-200/70">
              <div className="w-16 h-16 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600">
                <i className="ri-information-line text-2xl w-8 h-8 flex items-center justify-center"></i>
              </div>
              <div className="text-left">
                <p className="text-sm text-foreground-700 font-medium mb-1">
                  {activeTab === 'ios' ? 'iOS安装提示' : '安卓安装提示'}
                </p>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {activeTab === 'ios'
                    ? '下载完成后，请前往「设置 → 通用 → 设备管理」中信任企业证书，即可正常使用。如遇问题请联系在线客服。'
                    : '下载APK文件后，请在手机「设置 → 安全」中开启「允许安装未知来源应用」，然后点击安装包完成安装。'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}